<template>
  <div>
    <el-tabs v-model="activeTabName">
      <el-tab-pane name="账号" label="账号">
        <AccountListPage v-if="activeTabName == '账号'" />
      </el-tab-pane>
      <el-tab-pane name="角色" label="角色">
        <AccountRoleListPage v-if="activeTabName == '角色'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AccountListPage from "./AccountListPage";
import AccountRoleListPage from "./AccountRoleListPage";

export default {
  data() {
    return {
      activeTabName: "账号",
    };
  },

  components: {
    AccountListPage,
    AccountRoleListPage,
  },
};
</script>